export default __webpack_public_path__ + "static/media/usuario.0f1e9440.png";